module.exports = __webpack_public_path__ + "static/media/horse.3a370dce.ogg";